export default __webpack_public_path__ + "static/media/palak.e2e507b1.jpg";